import React from "react";
import EN from "../../../locales/en";
import interpolate from "../../../utils/interpolate";

const QuoteTariffEstimatedCostsBox = ({ quote }) => {
  const estimatedMonthlyCost = (
    parseFloat(quote?.newSpendMonthlyDDElec ?? 0) +
    parseFloat(quote?.newSpendMonthlyDDGas ?? 0)
  ).toFixed(2);
  const estimatedAnnualCost = parseFloat(quote?.newSpend ?? 0).toFixed(2);
  const estimatedSavings = parseFloat(quote?.newSavings ?? 0).toFixed(2);

  return (
    <div className="mt-2 border-2 border-primary rounded-[4px] p-4">
      <h4 className="text-md font-bold leading-[1.5]">
        {EN.quotes.estimated_monthly_cost_text}
      </h4>
      <p className="text-[22px] font-bold">£{estimatedMonthlyCost}</p>

      <p className="mt-2 italic">{EN.quotes.price_includes_vat_text}</p>

      <p className="mt-2">
        {interpolate(EN.quotes.switching_to_this_plan_text, {
          estimatedSavings,
        })}
      </p>

      <p className="mt-2">
        {EN.quotes.estimated_annual_cost_text} £{estimatedAnnualCost}
      </p>
    </div>
  );
};

export default QuoteTariffEstimatedCostsBox;
